<div class="cancelar">

    <h1 mat-dialog-title>Confirmação</h1>
    <div mat-dialog-content>
      <p>{{ data.message }}</p>
    </div>
    <div mat-dialog-actions>
        
      <button mat-button *ngIf="!data.showSuccessMessage"(click)="close()">Não</button>
      <button mat-button *ngIf="data.showSuccessMessage" (click)="close()">Fechar</button>
      <button mat-button *ngIf="!data.showSuccessMessage"[mat-dialog-close]="true">Sim</button>
    </div>
    
</div>
